import { connect } from 'react-redux';
import { getPageSize } from '../publicSession/selectors';
const mapStateToProps = (state)=>({
        pageSize: getPageSize(state)
    });
export default connect(mapStateToProps);
